<input type="checkbox" id="darkmode-toggle" />
<label for="darkmode-toggle" (click)="changeMode()">
    <!-- <img src="/assets/images/sun.svg" />
    <img src="/assets/images/moon.svg" /> -->
</label>